<!-- Affichage lorsqu'il n'y a aucun message -->
@if (room.messages.length === 0) {
    <div>
        <h1>Vous démarrez une nouvelle conversation</h1>
        <h3>Tapez votre premier message ci-dessous...</h3>
    </div>
}

<!-- Affichage lorsqu'il y a des messages -->
@if (room.messages.length !== 0) {
    <div class="historics-container" #scrollingContainer>
        @for (message of room.messages; track message.guid; let index = $index) {
            <div class="historic">
                <app-tchat-room-message
                    [isLiveTchat]="isLiveTchat"
                    [message]="message"
                    [sourceUser]="sourceUser"
                    [previousMessageUser]="room.messages[index - 1]?.sourceUser"></app-tchat-room-message>
            </div>
        }
    </div>
}
